import Swal from 'sweetalert2';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

export default function() {
  const accountUrl = $('body').attr('data-account-url');
  const recordType = $('#saveDashboardSections').attr('data-record-type');
  const reportId = $('.included-sections').attr('data-report-id');
  const dashboardId = $('.included-sections').attr('data-dashboard-id');
  let isProcessing = false; // variable to avoid concurrent processing of sortupdate events

  // Define template for section
  const sectionTemplate = function(el, inclusionId, sectionId, sortOrder) {

    // Build template
    let template = "<div class=\'section-inclusion d-none\'"
    template += " data-section-id=\'" + sectionId + "\'"
    if (typeof inclusionId !== 'undefined') {
      template += " data-inclusion-id=\'" + inclusionId + "\'"
    }
    template += ">"
    if (typeof inclusionId !== 'undefined') {
      template += "<input id=\'inclusion_id_" + inclusionId + "\' type=\'hidden\' value=\'" + inclusionId + "\' "
      template += "name=\'" + recordType + "[section_inclusions_attributes][" + sortOrder + "][id]\' data-lpignore=\'true\' autocomplete=\'off\'>"
    }

    template += "<input type=\'hidden\' value=\'" + sectionId + "\' "
    template += "name=\'" + recordType + "[section_inclusions_attributes][" + sortOrder + "][section_id]\' "
    template += "id=\'" + recordType + "_section_inclusions_attributes_" + sortOrder + "_section_id\' data-lpignore=\'true\' autocomplete=\'off\'>"

    template += "<input type=\'hidden\' value=\'" + sortOrder + "\' "
    template += "name=\'" + recordType + "[section_inclusions_attributes][" + sortOrder + "][sort_order]\' "
    template += "class=\'sort-order\' "
    template += "id=\'" + recordType + "_section_inclusions_attributes_" + sortOrder + "_sort_order\' data-lpignore=\'true\' autocomplete=\'off\'>"
    template += "</div>"

    // Return template
    return template

  }

  // On single click of section
  $('ul.included-sections:not(.locked) li').on('click', function() {
    let inclusionId = $(this).attr("data-inclusion-id");
    let scrollPosition = $('#includedSectionsListContainer').scrollTop();
    let url = '/' + accountUrl + '/sections/inclusions/' + inclusionId + '/edit';
    let params = {sp: scrollPosition};
    Turbo.visit(url + '?' + $.param(params));
  });

  // Sort available sections by title text
  function sortAvailableSections() {
    let availableList = $('ul.sortable-sections.available-sections');
    let items = availableList.children('li').get();
    
    items.sort(function(a, b) {
      let titleA = $(a).find('.title').text().trim().toLowerCase();
      let titleB = $(b).find('.title').text().trim().toLowerCase();
      return titleA.localeCompare(titleB);
    });
    
    $.each(items, function(idx, item) {
      availableList.append(item);
    });
  }

  // Adjust to full or half width on dragging
  $('.sortable-sections:not(.locked)').sortable({
    placeholder: "available-module-space",
    handle: '.drag-module',
    connectWith: $('.sortable-sections'),
    items: "li:not([data-disabled]):not([data-unsortable='true'])", // Exclude li elements with data-disabled or data-unsortable="true"
    start: function( event, ui ) {
      $('[data-toggle=tooltip]').tooltip('hide');
      let isCol12 = ui.item.hasClass('col-12');
      if (isCol12) {
        $('.available-module-space').addClass('full-width');
      } else {
        $('.available-module-space').removeClass('full-width');
      }
      let fromAvailable = ui.item.closest('.included-sections-container').length == 0;
      if (fromAvailable) {
        $('.available-module-space').addClass('full-height');
      } else {
        $('.available-module-space').removeClass('full-height');
      }
    }
  });

  // Sorting included items
  $('#includedSections').on("sortupdate", function(event, ui) {
    if(isProcessing) return; // Prevent concurrent processing of events
    isProcessing = true;
    let processingTimeout = setTimeout(() => { isProcessing = false; }, 3000); // 3s timeout to reset isProcessing if the previous AJAX call fails

    // Set whether receiving list is available
    let toIncluded = $(ui.item).parent().hasClass('included-sections')
    let toAvailable = $(ui.item).parent().hasClass('available-sections');

    // Set allowed record types
    let allowed = $(ui.item).attr('data-allowed-record-types');
    let t = $('.sections-container').attr('data-reportable-type');

    // Change to green color
    $(ui.item).find('path').css('fill', '#AAEBBD');

    // Add, update or remove item 
    let el = $(ui.item);
    let inclusionId = el.attr('data-inclusion-id');
    if (toIncluded) {
      let sectionId = el.attr('data-section-id');
      let sortOrder = el.index() + 1;
      let existing = $('.section-inclusion[data-section-id=\'' + sectionId + '\']');
      let template = sectionTemplate(el, inclusionId, sectionId, sortOrder, "false");

      // Add an inclusion first, so can track correct id to update
      if (typeof inclusionId === 'undefined') {
        let url = '/' + accountUrl + '/sections/inclusions';
        let params = {};
        params['section_inclusion'] = {}
        params['section_inclusion']['section_id'] = sectionId;
        params['section_inclusion']['sort_order'] = sortOrder;
        if (typeof reportId !== 'undefined') {
          params['section_inclusion']['report_id'] = reportId;
        }
        if (typeof dashboardId !== 'undefined') {
          params['section_inclusion']['dashboard_id'] = dashboardId;
        }
        $.ajax({
          type: 'POST',
          dataType: 'application/json',
          url: url + '?' + $.param(params),
          complete(result) {
            clearTimeout(processingTimeout);
            isProcessing = false;
            let responseText = {};
            try {
              responseText = JSON.parse(result.responseText);
            } catch (error) {
              responseText = {};
            }

            if (responseText.status === 400) {
              ToastCustom({title: 'Section limit reached', message: responseText.error || 'Cannot add more than 50 sections', delay: 5000, type: 'urgent'});
              // Move the section back to the available list since it was not added
              el.attr('data-inclusion-id', null);
              el.find('path').css('fill', '#E4E4EA');
              $('ul.sortable-sections.available-sections').append(el);
              sortAvailableSections();
              return;
            }

            let newId = responseText.id;

            // Update inclusion id for list of included sections
            let existing = $('.section-inclusion[data-section-id=\'' + sectionId + '\']');
            let template = sectionTemplate(el, newId, sectionId, sortOrder, "false");
            if (existing.length !== 0) {
              existing.replaceWith(template);
            } else {
              $('.section-inclusions-list').append(template);
            }

            // Add inclusion ID as a data attribute to section el
            el.attr('data-inclusion-id', newId);

            // Remove any indication that multiple allowed
            el.find('.multiple-allowed').remove();

            // Direct user to edit the section if any custom fields
            // Otherwise set on click function
            let hasRequiredCustomFields = el.attr('data-has-required-custom-fields');
            let inclusionId = newId;
            let url = '/' + accountUrl + '/sections/inclusions/' + inclusionId + '/edit';
            if (hasRequiredCustomFields === 'true') {
              let scrollPosition = $('#includedSectionsListContainer').scrollTop();
              let params = {};
              params['custom_fields'] = true;
              params['sp'] = scrollPosition;
              Turbo.visit(url + '?' + $.param(params));
            } else {
              $(el).on('click', function() {
                let scrollPosition = $('#includedSectionsListContainer').scrollTop();
                let params = {sp: scrollPosition};
                Turbo.visit(url + '?' + $.param(params));
              });
            }

          },
        });

        // If section allows multiple to be added, clone and keep a copy in the available list
        let allowsMultiple = el.attr('data-allow-multiple');
        if (allowsMultiple === "true") {
          let cloned = el.clone();
          cloned.find('path').css('fill', '#E4E4EA');
          cloned.appendTo($('ul.sortable-sections.available-sections'));
          
          // Re-sort available sections after adding new item
          sortAvailableSections();
        }      
      }

    } else if (toAvailable) {
      $(ui.item).find('path').css('fill', '#E4E4EA');

      // Remove from list of inclusions
      $('.section-inclusion[data-inclusion-id=\'' + inclusionId + '\']').remove();

      // Delete section inclusion
      let url = '/' + accountUrl + '/sections/inclusions/' + inclusionId;
      let params = {};
      if (typeof reportId !== 'undefined') { params['report_id'] = reportId; }
      if (typeof dashboardId !== 'undefined') { params['dashboard_id'] = dashboardId; }
      $.ajax({
        type: 'DELETE',
        dataType: 'application/json',
        url: url + '?' + $.param(params),
        complete(result) {
          clearTimeout(processingTimeout);
          isProcessing = false;
          // Remove inclusion ID as a data attribute on element
          $(ui.item).attr('data-inclusion-id', null);

        }
      });

      // Remove ui item if multiple allowed (there will already be an available section there)
      let allowsMultiple = $(ui.item).attr('data-allow-multiple');
      if (allowsMultiple === "true") {
        $(ui.item).remove();
      }

    }

    // Update sort order of all included sections
    let sectionInclusions = $('.section-inclusion');
    $.each(sectionInclusions, function(ind, inclusion) {
      let el = $(inclusion);
      let inclusionId = el.attr('data-inclusion-id');
      let sectionId = el.attr('data-section-id');
      let includedSectionEl = $('.included-sections-container').find('li[data-inclusion-id=\'' + inclusionId + '\']');
      let sortOrder;
      if (includedSectionEl.length !== 0) {
        sortOrder = includedSectionEl.index() + 1;
      } else {
        sortOrder = Math.floor(Math.random() * (100001 - 100) + 100);
      } 
      let template = sectionTemplate(el, inclusionId, sectionId, sortOrder);
      includedSectionEl.attr('data-sort-order', sortOrder);
      el.attr('data-sort-order', sortOrder);
      el.replaceWith(template);

    });

    // Set param to redirect to current page
    $('#render_update').val('true');

    // Set scroll of sections container
    let scrollFilter = $('#includedSectionsListContainer').scrollTop();
    $('#updateDashboard').prepend('<input type="hidden" name="sp" value="' + scrollFilter + '">');

    // Submit form to update
    $('#saveDashboardSections').click();

  });

  // Filter the list of available sections on type in the #search_sections input field
  $('#search_sections').on('input', function() {
    let searchTerm = $(this).val().toLowerCase();
    $('ul.sortable-sections.available-sections li').each(function() {
      let sectionName = $(this).find('.section-name').text().toLowerCase();
      let disabled = $(this).data('disabled') === true;
      if (sectionName.includes(searchTerm) && !disabled) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  // Update dashboard on click
  $('#saveDashboardAndNext').click(function() {
    $('#render_update').val('false');
    $('#redir_to_dashboard').val('false');
    $('#saveDashboardSections').click();
  })

  // Update report on click
  $('#updateReportNext').click(function() {
    $('#render_update').val('false');
    $('#redir_to_benchmarks').val('true');
    $('#saveDashboardSections').click();
  })


}
